import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import "react-dropzone-uploader/dist/styles.css";
import Dropzone from "react-dropzone-uploader";

import User from "../../../assets/img/user.png";
import Close from "../../../assets/img/close.png";
import Pouse from "../../../assets/img/pouse.png";

import { getDroppedOrSelectedFiles } from "html5-file-selector";
import { Card } from "react-bootstrap";

import {updatePhoto} from '../../../redux/features/user/actions'
import {setUser} from '../../../redux/features/user/slice'

function UploadAvatar({user , setUser}) {
  const getUploadParams = () => ({ url: "https://httpbin.org/post" });

  const handleSubmit = (files, allFiles) => {
    allFiles.forEach((f) => f.remove());
  };

  const getFilesFromEvent = (e) => {
    return new Promise((resolve) => {
      getDroppedOrSelectedFiles(e).then((chosenFiles) => {
        resolve(chosenFiles.map((f) => f.fileObject));
      });
    });
  };

  /**
   *  Preview
   */
  const Preview = ({ meta, files }) => {
    const cancel = () => {
      files.forEach((f) => f.remove());
    };

    const upload = () => {
      let fd = new FormData()
      files.forEach((f) => fd.append('photo' , f.file));

      updatePhoto(fd).then(res => {
        if (res) {
          setUser(res)
          cancel()
        }
      })
    }

    let { status, previewUrl, name, percent, size } = meta;

    const formatBytes = (bytes, decimals = 1) => {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    return (
      <div className="preview">
        <Card className={`upload bordered ${status}`}>
          {/* Progress */}
          {status !== "done" && (
            <div
              className={`upload-progress ${
                Math.round(percent) == 100 ? "done" : ""
              }`}
              style={{ width: `calc(${Math.round(percent)}% + 4px)` }}
            />
          )}

          <Card.Body>
            <img
              src={status === "uploading" ? user.photo || User : previewUrl}
              alt="user"
              className="rounded-full"
            />
            <div className="box-holder">
              <div>
                <p>
                  {status === "uploading" ? "Uploading..." : name}
                  {status === "done" && (
                    <span className="size">{formatBytes(size)}</span>
                  )}
                </p>
                <p className="text-success">{Math.round(percent)}%</p>
              </div>
              <div className={`actions ${status}`}>
                {status === "uploading" ? (
                  <>
                    {/* <img src={Pouse} alt="pouse" />
                    <img src={Close} alt="close" /> */}
                  </>
                ) : (
                  <>
                    <span onClick={() => upload()}>
                      <i className="las la-check text-success m-0" ></i>
                    </span>

                    <span className="text-danger" onClick={() => cancel()}>
                      <i className="las la-trash-alt text-danger"></i>
                      Remove Picture
                    </span>
                  </>
                )}
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  };

  /**
   * Input
   */
  const Input = ({ accept, onFiles, files, getFilesFromEvent }) => {
    return (
      <>
        {!files.length && (
          <label>
            <Card className="upload bordered">
              <Card.Body>
                <img src={user.photo || User} alt="user" className="rounded-full" />
                <div className="box-holder">
                  <div>
                    <p>
                      <span className="text-info pointer">
                        Click to replace
                      </span>{" "}
                      or drag and drop
                    </p>
                    <p>PNG, JPG, & JPEG (max. 4mb)</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
            <input
              style={{ display: "none" }}
              type="file"
              accept={accept}
              multiple
              onChange={(e) => {
                getFilesFromEvent(e).then((chosenFiles) => {
                  onFiles(chosenFiles);
                });
              }}
            />
          </label>
        )}
      </>
    );
  };

  return (
    <div className="uploadAvatar">
      <Dropzone
        getUploadParams={getUploadParams}
        onSubmit={handleSubmit}
        PreviewComponent={Preview}
        InputComponent={Input}
        getFilesFromEvent={getFilesFromEvent}
        disabled={(files) =>
          files.some((f) =>
            ["preparing", "getting_upload_params", "uploading"].includes(
              f.meta.status
            )
          )
        }
        SubmitButtonComponent="remove"
      />
    </div>
  );
}

const mapDispatchToProps = {
  setUser,
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
});

UploadAvatar.propTypes = {
  user: PropTypes.object.isRequired,
};

export default connect(mapStateToProps , mapDispatchToProps)(UploadAvatar);
